import { html, render, TemplateResult } from "lit";
import { ViewBase } from "./views/view-base";
import { CommercialSearchView, ResidentialSearchView } from "./views/search-filtered-view";
import { hash, pageNames } from "./views/view-consts";
import { registerBootstrapComponent } from "./components/bootstrap-wrapper";
import './components/star-selector';
import { ModalExecutor, setModalLauncher } from "./views/modal-wrapper";
import { SkyLightsView } from "./views/skylights-view";
import { FilmsView } from "./views/films-view";

class FrontPage {

    renderingCount: number = 0;
    container: HTMLElement;

    pages: Array<ViewBase> = [];
    currentPage: string = pageNames.residentialSearch;
    //this needs to be hardcoded to an AGWA domain
    homePageLink: string = 'http://www.agwa.com.au/wers';

    constructor(container: HTMLElement, startPage: string) {
        this.addPages();
        this.container = container;
        window.addEventListener("hashchange", async (e) => {
            if (window.location.hash === "") {
                window.location.hash = '#' + pageNames.residentialSearch;
                //await this.setPage(pageNames.residentialSearch);
            } else if (await this.setPage(window.location.hash.slice(1))) {
                e.preventDefault();
            } else {
                window.location.hash = '#' + pageNames.residentialSearch;
            }
        });
    }
    addPages() {
        const renderEvent = async () => await this.render();
        this.pages.push(new CommercialSearchView(pageNames.commercialSearch, renderEvent));
        this.pages.push(new ResidentialSearchView(pageNames.residentialSearch, renderEvent));
        this.pages.push(new SkyLightsView(pageNames.skylights, renderEvent));
        this.pages.push(new FilmsView(pageNames.films, renderEvent));
    }
    pageTitle(): string { return 'WERS Search'; }
    private async activePageTemplate(): Promise<TemplateResult> {
        return this.pages.find(x => x.name === this.currentPage)?.template() ?? html``;
    }
    public async template(): Promise<TemplateResult> {
        return html`
        <header>
            <nav class="navbar navbar-expand-sm navbar-light bg-light">
                <div class="container-fluid">
                    <a class="navbar-brand" href=${this.homePageLink}><img src="./images/WERS-Logo-2021.svg"
                            style="height:50px;" /></a>
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                        aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul class="navbar-nav  mb-2 mb-lg-0">
                            <li class="nav-item">
                                <a class="nav-link text-dark" href=${hash(pageNames.residentialSearch)}>Residential</a>
                            </li>
                        </ul>
                        <ul class="navbar-nav  mb-2 mb-lg-0">
                            <li class="nav-item">
                                <a class="nav-link text-dark" href=${hash(pageNames.commercialSearch)}>Commercial</a>
                            </li>
                        </ul>
                        <ul class="navbar-nav  mb-2 mb-lg-0">
                            <li class="nav-item">
                                <a class="nav-link text-dark" href=${hash(pageNames.skylights)}>Skylights</a>
                            </li>
                        </ul>
                        <ul class="navbar-nav  mb-2 mb-lg-0">
                            <li class="nav-item">
                                <a class="nav-link text-dark" href=${hash(pageNames.films)}>Films</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
        </header>
        <div class=" main">
            ${await this.activePageTemplate()}
        </div>
        
        <footer class="border-top footer text-muted">
            <div class="footer-container px-3">
                &copy; 2021 - AGWA
            </div>
        </footer>

          `;
    }
    async setPage(newPageName: string): Promise<boolean> {
        const page = this.pages.filter(x => x.name === newPageName)[0] ?? null;
        if (page) {
            const currentPage = this.pages.filter(x => x.name === this.currentPage)[0] ?? null;
            if (currentPage)
                await currentPage.deActivatePage();
            this.currentPage = newPageName;
            await page.activatePage();
            await this.render();
            return true;
        } else {
            return false;
        }
    }
    public async render() {
        this.renderingCount++;
        try {
            if (this.renderingCount > 1) return;
            render(await this.template(), this.container);
            //        let selects: any = $(this.container).find('select');
            //      selects.select2();
            const page = this.pages.filter(x => x.name === this.currentPage)[0] ?? null;
            if (page)
                page.afterRender();
        } finally {
            this.renderingCount--;
        }
    }

}


(function () {

    function documentReady(fn) {
        if (document.readyState === 'complete' || document.readyState === 'interactive') {
            setTimeout(fn, 1);
        }
        else {
            document.addEventListener('DOMContentLoaded', fn);
        }
    }
    registerBootstrapComponent();
    globalThis.wersSearch = {
        main: {
            initView: function (appContainer: HTMLDivElement, modalLauncher: ModalExecutor) {
                documentReady(async () => {
                    setModalLauncher(modalLauncher);

                    let pageHash = window.location.hash;
                    if (pageHash) pageHash = pageHash.slice(1);

                    const page = new FrontPage(appContainer, pageHash);
                    if (!await page.setPage(pageHash)) window.location.hash = '#' + pageNames.residentialSearch;
                    //page.render();
                });

            }
        }
    };

})();
